import { render, staticRenderFns } from "./shopMlogin.vue?vue&type=template&id=4573d64c&scoped=true&"
import script from "./shopMlogin.vue?vue&type=script&lang=js&"
export * from "./shopMlogin.vue?vue&type=script&lang=js&"
import style0 from "./shopMlogin.vue?vue&type=style&index=0&id=4573d64c&prod&lang=css&"
import style1 from "./shopMlogin.vue?vue&type=style&index=1&id=4573d64c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4573d64c",
  null
  
)

export default component.exports